export const lenguageIngles = {
  home: {
    title: "Hello, welcome",
  }
}